import React, { useEffect } from "react";

//* ReactFlow Library
import ReactFlow, { Controls, MiniMap } from "reactflow";

import {
  nodeTypes,
  edgesTypes,
  generateNodesData,
  generateEdgesData,
  getAllTeamsKeyVal,
  defaultEdgeOptions,
  defaultViewport,
  proOptions,
  hoverToHighlight,
  longTextHover,
} from "./utilities/helper";

const BracketView = (props) => {
  const brackets = props.bracket[0] || [];
  const hideSeed = props.hide_bracket_seed;
  const hasWorkingTeam = props.has_working_team;

  const titlesNode = props.titles || [];
  const bracketsData = brackets.map((bracket) => bracket[0]);
  const teamDataObj = Object.values(props.team_type);
  const allTeams = getAllTeamsKeyVal(props.all_teams);

  useEffect(() => {
    //* Remove tooltip from the minimap
    document.getElementById("react-flow__minimap-desc-1").remove();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      hoverToHighlight();
      longTextHover();
    }, 500);
  }, [nodes]);

  const nodes = generateNodesData(
    [...bracketsData, ...titlesNode],
    teamDataObj,
    allTeams,
    true,
    false,
    true,
    hideSeed,
    [],
    hasWorkingTeam
  );

  const edges = generateEdgesData(props.edges || []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12 frontWrapper">
          <ReactFlow
            proOptions={proOptions}
            nodes={nodes}
            edges={edges}
            nodeTypes={nodeTypes}
            edgeTypes={edgesTypes}
            defaultViewport={defaultViewport}
            defaultEdgeOptions={defaultEdgeOptions}
            edgesFocusable={false}
            nodesFocusable={false}
            nodesDraggable={false}
            nodesConnectable={false}
            fitView
            panOnScroll
            minZoom={-Infinity}
          >
            <Controls showInteractive={false} />
            <MiniMap style={{ height: 120 }} zoomable pannable />
          </ReactFlow>
        </div>
      </div>
    </div>
  );
};

export default BracketView;
